module.exports = __webpack_public_path__ + "static/media/museumScreenshot.cb5b4c94.jpg";